import React from 'react';
import "./loading-full-page.css"

class LoadingFullScreen extends React.Component {


    render() {
        return (
            <>
                <div className="loader-container">
                    <div className={"loader-svg"} style={{display: 'in-line'}}>
                        <img src={require('./logo3.png')}
                             style={{display: 'inline', paddingLeft: '10px', paddingBottom: '15px', width: "50%"}} alt={'uShop Logo'}/>
                        <p style={{color: 'white', paddingTop: 0}}>Đang tải, vui lòng đợi trong giây lát ...</p>
                    </div>

                </div>
            </>
        )
    }
}

export default LoadingFullScreen;
